import { useTranslate } from "@ur-solutions/react-hooks";
import { useToast}  from "@ur-solutions/react-components";
import { useOnErrorAuto } from "../../../utils";
import { useMutation } from "@apollo/client";
import {
  CREATE_USER_EQUIPMENT_MUTATION,
  CREATE_USER_EQUIPMENT_TYPE_MUTATION,
  DELETE_USER_EQUIPMENT_MUTATION,
  DELETE_USER_EQUIPMENT_TYPE_MUTATION,
  PATCH_USER_EQUIPMENT_MUTATION,
  PATCH_USER_EQUIPMENT_TYPE_MUTATION
} from "../mutations";

export function useUserEquipmentTypeMutations() {
  const translations = useTranslate({
    success: {
      create: 'settings.toasts.create-user-equipment-type-success',
      patch: 'settings.toasts.patch-user-equipment-type-success',
      delete: 'settings.toasts.delete-user-equipment-type-success',
    },
    error: {
      create: 'settings.errors.create-user-equipment-type',
      patch: 'settings.errors.patch-user-equipment-type',
      delete: 'settings.errors.delete-user-equipment-type',
    },
  })

  const addToast = useToast()
  const onErrorAuto = useOnErrorAuto()

  const [create, {loading: createLoading}] = useMutation(
    CREATE_USER_EQUIPMENT_TYPE_MUTATION,
    {
      awaitRefetchQueries: true,
      refetchQueries: ['AllUserEquipmentTypes'],
      onCompleted(data) {
        if (!data) {
          addToast('error', translations.error.create)
          return
        }
        addToast('success', translations.success.create)
      },
      onError: onErrorAuto(translations.error.create),
    }
  )

  const [patch, {loading: patchLoading}] = useMutation(
    PATCH_USER_EQUIPMENT_TYPE_MUTATION,
    {
      awaitRefetchQueries: true,
      refetchQueries: ['AllUserEquipmentTypes'],
      onCompleted(data) {
        if (!data) {
          addToast('error', translations.error.patch)
          return
        }
        addToast('success', translations.success.patch)
      },
      onError: onErrorAuto(translations.error.patch),
    }
  )

  const [deleteMutation, {loading: deleteLoading}] = useMutation(
    DELETE_USER_EQUIPMENT_TYPE_MUTATION,
    {
      awaitRefetchQueries: true,
      refetchQueries: ['AllUserEquipmentTypes'],
      onCompleted(data) {
        if (!data) {
          addToast('error', translations.error.delete)
          return
        }
        addToast('success', translations.success.delete)
      },
      onError: onErrorAuto(translations.error.delete),
    }
  )

  return {
    create,
    patch,
    delete: deleteMutation,
    loading: createLoading || patchLoading || deleteLoading,
  }
}

export function useUserEquipmentMutations() {
  const translations = useTranslate({
    success: {
      create: 'settings.toasts.create-user-equipment-success',
      patch: 'settings.toasts.patch-user-equipment-success',
      delete: 'settings.toasts.delete-user-equipment-success',
    },
    error: {
      create: 'settings.errors.create-user-equipment',
      patch: 'settings.errors.patch-user-equipment',
      delete: 'settings.errors.delete-user-equipment',
    },
  })

  const addToast = useToast()
  const onErrorAuto = useOnErrorAuto()

  const [create, {loading: createLoading}] = useMutation(
    CREATE_USER_EQUIPMENT_MUTATION,
    {
      awaitRefetchQueries: true,
      refetchQueries: ['AllUserEquipment'],
      onCompleted(data) {
        if (!data) {
          addToast('error', translations.error.create)
          return
        }
        addToast('success', translations.success.create)
      },
      onError: onErrorAuto(translations.error.create),
    }
  )

  const [patch, {loading: patchLoading}] = useMutation(
    PATCH_USER_EQUIPMENT_MUTATION,
    {
      awaitRefetchQueries: true,
      refetchQueries: ['AllUserEquipment'],
      onCompleted(data) {
        if (!data) {
          addToast('error', translations.error.patch)
          return
        }
        addToast('success', translations.success.patch)
      },
      onError: onErrorAuto(translations.error.patch),
    }
  )

  const [deleteMutation, {loading: deleteLoading}] = useMutation(
    DELETE_USER_EQUIPMENT_MUTATION,
    {
      awaitRefetchQueries: true,
      refetchQueries: ['AllUserEquipment'],
      onCompleted(data) {
        if (!data) {
          addToast('error', translations.error.delete)
          return
        }
        addToast('success', translations.success.delete)
      },
      onError: onErrorAuto(translations.error.delete),
    }
  )

  return {
    create,
    patch,
    delete: deleteMutation,
    loading: createLoading || patchLoading || deleteLoading,
  }
}
